import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IconButton, Tooltip, Popover, Box, Typography, Divider,
  List, ListItem, FormControlLabel, Checkbox, Button
} from '@mui/material';
import { Rule } from '@mui/icons-material';
export const InventoryColumnSelector = ({
  columns,
  visibleColumns,
  onChange,
  columnsIgnored = [],
  tooltipTitle = 'Seleccionar columnas',
  title = 'Columnas visibles',
  iconSize = 30,
}) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (event) => {


    setAnchorEl(event.currentTarget);

  };
  const handleClose = () => setAnchorEl(null);

  const handleToggle = (columnId) => {

    const next = visibleColumns.includes(columnId)
      ? visibleColumns.filter(id => id !== columnId)
      : [...visibleColumns, columnId];
    console.log('visibles después:', next);

    onChange(next);

  };

  const handleShowAll = () => {
    onChange(columns.map(column => column.id));
  };

  const handleHideAll = () => {
    onChange(columns.filter(column => columnsIgnored.includes(column.id)).map(column => column.id));
  };

  const selectableColumns = columns.filter(column => !columnsIgnored.includes(column.id));

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <IconButton aria-label="select-columns" onClick={handleOpen}>
          <Rule style={{ fontSize: iconSize }} />
        </IconButton>
      </Tooltip>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box sx={{ p: 1, minWidth: 240, maxHeight: 400, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="subtitle2" sx={{ px: 1, py: 0.5 }}>
            {title}
          </Typography>
          <Divider />

          <List dense sx={{ overflowY: 'auto', flexGrow: 1 }}>
            {selectableColumns.map(column => (
              <ListItem key={column.id} disablePadding sx={{ pl: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={visibleColumns.includes(column.id)}
                      onChange={() => handleToggle(column.id)}
                      size="small"
                    />
                  }
                  label={column.label ?? column.id}
                />
              </ListItem>
            ))}
          </List>

          <Divider />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1 }}>
            <Button size="small" onClick={handleHideAll}>Ocultar todas</Button>
            <Button size="small" onClick={handleShowAll}>Mostrar todas</Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

InventoryColumnSelector.propTypes = {
  columns: PropTypes.array.isRequired,
  visibleColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  columnsIgnored: PropTypes.arrayOf(PropTypes.string),
  tooltipTitle: PropTypes.string,
  title: PropTypes.string,
  iconSize: PropTypes.number,
};